module.exports = __webpack_public_path__ + "static/media/PR5.33be9ae9.jpg";